import { styled } from 'libs/ui/styled';

export const ContainerStyled = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(352px, 1fr))',
  gap: '12px',
}));
